import ScrollSmoother from './ScrollSmoother'
import ScrollManager from './ScrollManager'
import Hamburger from './Hamburger'
// import LineScrollAnimation from './LineScrollAnimation'
// import Accordion from './Accordion'
// import PrintButton from './PrintButton'
// import AutoMovingSlides from './AutoMovingSlides'
import AnchorScroll from './AnchorScroll'
import TextLoopAnimation from './TextLoopAnimation'
// import ScrollPositionCounter from './ScrollPositionCounter'
// import EntryModal from './EntryModal'
import Parallax from './Parallax'
// import FormValidation from './FormValidation'
// import ModalVideo from './ModalVideo'

export default class {
  constructor() {

    new ScrollSmoother();

    // const domMvAnimation = document.querySelector('[data-js="visual-animation"]');
    // if (!domMvAnimation) {
    //   document.body.style.setProperty('--animation-val', '0');
    //   document.body.style.setProperty('--animation-val-bottom', '0');
    // }

    const domScroller = document.querySelector('[data-scroller]');
    if (domScroller) new ScrollManager(domScroller);

    const domHamburger = document.querySelector('[data-js="trigger"]');
    if (domHamburger) new Hamburger(domHamburger);

    const domAnchorScroll = [...document.querySelectorAll('a[href^="#"]')];
    if ( domAnchorScroll ) {
      domAnchorScroll.forEach(el => {
        new AnchorScroll(el);
      });
    }

    // const domAccordion = document.querySelectorAll('[data-js="accordion"]');
    // if (domAccordion) {
    //   [...domAccordion].forEach(el=>{
    //     new Accordion(el);
    //   });
    // }

    // const domLineScrollAnimationVisual = document.querySelectorAll('[data-js="line-animation"]');
    // if (domLineScrollAnimationVisual) {
    //   [...domLineScrollAnimationVisual].forEach(el=>{
    //     new LineScrollAnimation(el);
    //   })
    // }

    // const domPrintButton = document.querySelectorAll('[data-js="print"]');
    // if (domPrintButton) {
    //   [...domPrintButton].forEach(el=>{
    //     new PrintButton(el);
    //   });
    // }  

    const domTextLoopAnimation = document.querySelector('[data-js="tick"]');
    if (domTextLoopAnimation) new TextLoopAnimation(domTextLoopAnimation);

    // const domAutoMovingSlides = document.querySelectorAll('[data-js="auto-moving-slides"]');
    // if (domAutoMovingSlides) {
    //   [...domAutoMovingSlides].forEach(el=>{
    //     new AutoMovingSlides(el);
    //   });
    // }

    // const domEntryModal = document.querySelectorAll('[data-js="entry-modal-trigger"]');
    // if (domEntryModal) new EntryModal(domEntryModal);

    // const domModalVideo = document.querySelectorAll('[data-js="modal-video"]');
    // if (domModalVideo) {
    //   [...domModalVideo].forEach(el=>{
    //     new ModalVideo(el);
    //   })
    // }

    new Parallax();

    // const domFormValidation = document.querySelector('.ctct-contents-form');
    // if (domFormValidation) new FormValidation(domFormValidation);

    // const domScrollPositionCounter = document.querySelector('[data-js="position-counter"]');
    // if (domScrollPositionCounter) new ScrollPositionCounter(domScrollPositionCounter);

    setTimeout(() => {
      document.body.dataset.loaded = true;
    }, 1200);
  }
}
